import { Component } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs";
import { Functionality } from "../../constants/functionality.constants";
import { GrafanaService } from "../../services/grafana.service";
import { PermissionService } from "../../services/permission.service";
import { OrganizationService } from "src/app/epicare-public/administration/domain/services/organization.service";

@Component({
  selector: "app-navigation",
  templateUrl: "./navigation.component.html",
  styleUrls: ["./navigation.component.scss"],
})
export class NavigationComponent {
  isMetadataPage = false;

  constructor(
    private router: Router,
    private permissionService: PermissionService,
    private organizationService: OrganizationService,
    private grafanaService: GrafanaService
  ) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.isMetadataPage = this.router.url.startsWith("/home/metadata/");
    });
  }

  /**
   * Whether the user's role allows uploading data
   */
  get canImportData(): boolean {
    return this.permissionService.isEnabled(Functionality.IMPORT_DATA);
  }

  /**
   * Whether the user's role allows opening Grafana, i.e. seeing the analytics
   */
  get canOpenGrafana(): boolean {
    return this.grafanaService.canOpenGrafana();
  }

  /**
   * Whether the user's role grants access to the administration section
   */
  get canAccessAdministration(): boolean {
    return this.permissionService.canAccessAdministration;
  }

  /**
   * Whether the user administrates every organization (SuperAdmin) rather than only their own (admin)
   */
  get canViewAllOrganizations(): boolean {
    return this.organizationService.canGetAllOrganizations();
  }

  /**
   * Open the analytics, i.e. Grafana in a new tab, already logged in
   */
  openGrafana(): void {
    this.grafanaService.openGrafana();
  }
}
